import React, { ComponentType, FunctionComponent, useMemo } from 'react';
import { get } from 'lodash';
import { Choice } from '../../config/types/field';

/**
 * Takes the choices from the record's `params.source` attribute, a list of
 * values sent by the API (e.g. available_contract_templates), instead of the
 * configured ones
 *
 * @param Component
 * @param params { source: string }
 */
function withChoicesFromRecord(
  Component: ComponentType<any>,
  params: Record<string, any> | undefined
): FunctionComponent {
  const Extension: FunctionComponent<Record<string, any>> = (props) => {
    const { choices, record } = props;
    const values = get(record, params?.source as string);

    const recordChoices = useMemo(
      () =>
        Array.isArray(values)
          ? values.map((value: string): Choice => ({ id: value, name: value }))
          : choices,
      [values, choices]
    );

    return <Component {...props} choices={recordChoices} />;
  };

  Extension.displayName = `withExtension(choicesFromRecord)`;

  return Extension;
}

export default withChoicesFromRecord;
